import Navbar from '../components/Navbar';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const CGVPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      
      <div className="container-app py-12">
        <Link to="/" className="inline-flex items-center text-sage-600 hover:text-sage-700 mb-8">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Retour à l'accueil
        </Link>
        
        <div className="max-w-4xl mx-auto bg-white rounded-2xl p-8 md:p-12 shadow-soft">
          <h1 className="font-heading text-3xl md:text-4xl font-semibold text-foreground mb-8">
            Conditions Générales de Vente (CGV)
          </h1>
          
          <p className="text-muted-foreground mb-8">
            Dernière mise à jour : Décembre 2024
          </p>
          
          <div className="prose prose-sage max-w-none">
            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">1. Objet</h2>
            <p className="text-muted-foreground mb-4">
              Les présentes Conditions Générales de Vente (CGV) régissent les transactions commerciales 
              effectuées sur la plateforme Opora Vie, notamment les réservations de consultations auprès 
              des Praticiens et les achats de produits numériques (livres, ebooks).
            </p>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">2. Prix et paiement</h2>
            <p className="text-muted-foreground mb-4">
              Les prix des consultations sont fixés librement par chaque Praticien et affichés sur leur 
              profil en euros (€), toutes taxes comprises.
            </p>
            <p className="text-muted-foreground mb-4">
              Les paiements sont effectués de manière sécurisée via notre prestataire Stripe. 
              Les modes de paiement acceptés sont :
            </p>
            <ul className="list-disc pl-6 text-muted-foreground mb-4 space-y-2">
              <li>Cartes bancaires (Visa, Mastercard, American Express)</li>
              <li>PayPal (selon disponibilité)</li>
            </ul>
            <p className="text-muted-foreground mb-4">
              Le paiement est exigé au moment de la réservation pour confirmer le rendez-vous.
            </p>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">3. Réservation et confirmation</h2>
            <p className="text-muted-foreground mb-4">
              La réservation d'une consultation est considérée comme ferme et définitive après :
            </p>
            <ul className="list-disc pl-6 text-muted-foreground mb-4 space-y-2">
              <li>Sélection d'un créneau horaire disponible</li>
              <li>Validation du paiement intégral</li>
              <li>Réception d'un email de confirmation</li>
            </ul>
            <p className="text-muted-foreground mb-4">
              Un lien de visioconférence est automatiquement généré pour les consultations en ligne 
              et communiqué aux deux parties.
            </p>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">4. Annulation et remboursement</h2>
            <h3 className="font-heading text-lg font-medium text-foreground mt-6 mb-3">Par le Client :</h3>
            <ul className="list-disc pl-6 text-muted-foreground mb-4 space-y-2">
              <li><strong>Plus de 48h avant le RDV :</strong> Remboursement intégral</li>
              <li><strong>Entre 24h et 48h avant :</strong> Remboursement de 50%</li>
              <li><strong>Moins de 24h avant :</strong> Aucun remboursement</li>
            </ul>
            
            <h3 className="font-heading text-lg font-medium text-foreground mt-6 mb-3">Par le Praticien :</h3>
            <p className="text-muted-foreground mb-4">
              En cas d'annulation par le Praticien, le Client sera intégralement remboursé et pourra 
              reprogrammer un rendez-vous à sa convenance.
            </p>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">5. Produits numériques (Boutique)</h2>
            <p className="text-muted-foreground mb-4">
              Les livres numériques (ebooks) achetés sur la boutique sont livrés instantanément par 
              téléchargement après validation du paiement.
            </p>
            <p className="text-muted-foreground mb-4">
              Conformément à l'article L221-28 du Code de la consommation, le droit de rétractation 
              ne s'applique pas aux contenus numériques fournis sur un support immatériel dont 
              l'exécution a commencé avec l'accord du consommateur.
            </p>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">6. Codes promotionnels</h2>
            <p className="text-muted-foreground mb-4">
              Les codes promotionnels sont soumis à des conditions spécifiques (durée de validité, 
              montant minimum, etc.) communiquées lors de leur diffusion. Ils ne sont ni cumulables 
              ni échangeables contre de l'argent.
            </p>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">7. Commission plateforme</h2>
            <p className="text-muted-foreground mb-4">
              Opora Vie prélève une commission sur chaque transaction effectuée via la plateforme. 
              Cette commission est transparente et communiquée aux Praticiens lors de leur inscription.
            </p>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">8. Réclamations</h2>
            <p className="text-muted-foreground mb-4">
              Pour toute réclamation relative à une transaction, le Client peut contacter notre 
              service client à l'adresse : 
              <a href="mailto:contact@apora.net" className="text-sage-600 hover:text-sage-700"> contact@apora.net</a>
            </p>
            <p className="text-muted-foreground mb-4">
              Les réclamations doivent être formulées dans un délai de 14 jours suivant la transaction.
            </p>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">9. Médiation</h2>
            <p className="text-muted-foreground mb-4">
              Conformément aux articles L.616-1 et R.616-1 du Code de la consommation, en cas de litige 
              non résolu, le consommateur peut recourir gratuitement à un médiateur de la consommation.
            </p>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">10. Droit applicable</h2>
            <p className="text-muted-foreground mb-4">
              Les présentes CGV sont soumises au droit français. Le tribunal compétent en cas de litige 
              est celui du ressort du siège social de la société Opora Vie.
            </p>
          </div>
        </div>
      </div>
      
      {/* Footer */}
      <footer className="py-8 bg-foreground text-white mt-12">
        <div className="container-app text-center">
          <p className="text-sand-300 text-sm">
            © 2024 Opora Vie. Tous droits réservés.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default CGVPage;
